import { combineDateTime, wallClockDatePart, wallClockTimePart } from '../../../lib/scheduleTime';

// A schedule date + time editor. Stores a WALL-CLOCK local datetime
// ('YYYY-MM-DDTHH:mm', no timezone) — resolved against the effective tz at publish.
// Picking a date alone fills the time with `defaultTime` (5:00am start / 10:00pm
// end); both are editable. Clearing the date clears the whole value (null).
export function ScheduleDateTimeField({
  label,
  value,
  defaultTime,
  onChange,
  hint,
  labelClassName = 'mb-1.5 block text-sm font-medium text-slate-700',
}: {
  label: string;
  value: string | null;
  defaultTime: string; // 'HH:mm' applied when a date is picked with no time yet
  onChange: (next: string | null) => void;
  hint?: string;
  labelClassName?: string;
}) {
  const date = wallClockDatePart(value);
  // Show the stored time, or the default once a date exists (so the AM sees 5am/10pm).
  const time = wallClockTimePart(value) || (date ? defaultTime : '');
  const inputClass =
    'rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-kyck-500 focus:outline-none focus:ring-1 focus:ring-kyck-500';

  return (
    <div>
      <label className={labelClassName}>{label}</label>
      <div className="flex gap-2">
        <input
          type="date"
          value={date}
          onChange={(e) => onChange(combineDateTime(e.target.value, time, defaultTime))}
          className={`flex-1 ${inputClass}`}
          aria-label={`${label} date`}
        />
        <input
          type="time"
          value={date ? time : ''}
          disabled={!date}
          onChange={(e) => onChange(combineDateTime(date, e.target.value, defaultTime))}
          className={`${inputClass} disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400`}
          aria-label={`${label} time`}
        />
      </div>
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </div>
  );
}
